












import { Vue, Component } from 'vue-property-decorator';
import BottomTabbarNew from './components/BottomTabbarNew.vue';
import Banner from '@/components/Banner.vue';
import * as config from './config';
import { appShare, wxShareInfo } from '@/common/ts/common';
import { baseinfo } from './api';

@Component({
  components: {
    Banner,
    BottomTabbarNew,
  },
})
export default class Home extends Vue {
  banner = require('./img/banner.jpg');
  option = config.OPTHINES;
  created() {
    baseinfo(this.option.voteName).then((res: any) => {
      this.$addPv(res.data.activityId);
    });

    appShare({
      title: '聚焦扶贫 福彩在行动',
      url: window.location.href,
      subtitle: '聚焦扶贫 福彩在行动',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      classId: -1,
      id: -1,
      type: 3,
    });
    wxShareInfo({
      title: '聚焦扶贫 福彩在行动',
      subtitle: '聚焦扶贫 福彩在行动',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
